interface PotentialReturnsOptions {
  stake: number;
  returnFactor: number;
  numberOfLines: number;
  isFreeBet: boolean;
}

export const calculatePotentialReturns = ({
  stake,
  returnFactor,
  numberOfLines,
  isFreeBet
}: PotentialReturnsOptions): number => {
  if (isNaN(stake)) {
    return 0;
  }

  const totalStake = stake * 100 * numberOfLines;
  const potentialReturn = totalStake * returnFactor;

  if (isFreeBet) {
    return potentialReturn - totalStake;
  }

  return potentialReturn;
};
